module.exports = __webpack_public_path__ + "img/carol.41df8832.png";